// Get jQuery from global scope
const $ = window.jQuery;

// Optimized visibility plugin - batch DOM reads to prevent forced reflows
(function ($) {
  $.fn.visible = function (partial) {
    const $t = $(this);
    const $w = $(window);
    const viewTop = $w.scrollTop();
    const viewBottom = viewTop + $w.height();
    const top = $t.offset().top;
    const bottom = top + $t.height();
    const compareTop = partial === true ? bottom : top;
    const compareBottom = partial === true ? top : bottom;

    return compareBottom <= viewBottom && compareTop >= viewTop;
  };
})(jQuery);

const win = $(window);
const allMods = $(".module");

// Batch initial visibility check
allMods.each(function (i, element) {
  const moduleElement = $(element);
  if (moduleElement.visible(true)) {
    moduleElement.addClass("already-visible");
  }
});

// Throttle scroll events to reduce forced reflows
let scrollTimeout;
win.scroll(function () {
  if (scrollTimeout) {
    window.cancelAnimationFrame(scrollTimeout);
  }

  scrollTimeout = window.requestAnimationFrame(function () {
    allMods.each(function (i, element) {
      const moduleElement = $(element);
      if (moduleElement.visible(true)) {
        moduleElement.addClass("come-in");
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const highlights = document.querySelectorAll(".highlight-text");

  const observerOptions = {
    threshold: 0.5,
    rootMargin: "0px 0px -100px 0px",
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("in-view");
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  highlights.forEach((highlight) => {
    observer.observe(highlight);
  });

  // Fade-in animation for statistics block text - use IntersectionObserver to avoid forced reflows
  const statisticsTextContainer = document.querySelector(
    ".statistics-block__text",
  );

  if (statisticsTextContainer) {
    const statisticsBlock =
      statisticsTextContainer.closest(".statistics-block");

    if (statisticsBlock) {
      // Only run animation on screens 1400px and above
      if (window.innerWidth < 1400) {
        statisticsTextContainer.classList.add("fade-in");
      } else {
        // Use IntersectionObserver instead of scroll events for better performance
        const fadeObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                statisticsTextContainer.classList.add("fade-in");
                fadeObserver.disconnect();
              }
            });
          },
          { threshold: 0.5 },
        );

        fadeObserver.observe(statisticsBlock);
      }
    }
  }

  // Count-up animation for stat values
  const statValues = document.querySelectorAll(
    ".small-stats-block__item-value, .dark-statistics-hero__statistic-number, .statistics-block__item-value",
  );

  const statObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const target = entry.target;
          const targetValue = target.getAttribute("data-target");

          // Extract number and suffix (%, £, etc.) - now handles + sign
          const match = targetValue.match(
            /^([£€$]?)([+-]?)([0-9,]+\.?[0-9]*)([%]?)$/,
          );
          if (match) {
            const prefix = match[1];
            const sign = match[2];
            const numberStr = match[3].replace(/,/g, "");
            const suffix = match[4];
            const number = parseFloat(numberStr);

            if (!isNaN(number)) {
              // Skip animation on screens below 1400px
              if (window.innerWidth < 1400) {
                const finalValue = Number(number).toLocaleString();
                target.textContent = prefix + sign + finalValue + suffix;
              } else {
                animateValue(target, 0, number, 10000, prefix, sign, suffix);
              }
            }
          }

          statObserver.unobserve(target);
        }
      });
    },
    { threshold: 0.5 },
  );

  statValues.forEach((stat) => {
    statObserver.observe(stat);
  });

  function animateValue(
    element,
    start,
    end,
    duration,
    prefix = "",
    sign = "",
    suffix = "",
  ) {
    let startTimestamp = null;
    const hasDecimals = end % 1 !== 0;

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const current = progress * (end - start) + start;

      let displayValue = hasDecimals ? current.toFixed(2) : Math.floor(current);
      displayValue = Number(displayValue).toLocaleString();

      element.textContent = prefix + sign + displayValue + suffix;

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        // Ensure final value is exact
        const finalValue = Number(end).toLocaleString();
        element.textContent = prefix + sign + finalValue + suffix;
      }
    };

    window.requestAnimationFrame(step);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const canvas = document.getElementById("dotsCanvas");
  if (!canvas) return;

  const ctx = canvas.getContext("2d");

  // Cache dimensions to avoid repeated reads
  let cachedWidth = 0;
  let cachedHeight = 0;
  let resizeTimeout;

  function resize() {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }

    // Debounce resize events
    resizeTimeout = setTimeout(() => {
      requestAnimationFrame(function () {
        // Batch DOM reads
        cachedWidth = canvas.offsetWidth;
        cachedHeight = canvas.offsetHeight;

        // Then do DOM writes
        canvas.width = cachedWidth;
        canvas.height = cachedHeight;
        digit1 = transformPoints(digit1Base);
        digit2 = transformPoints(digit2Base);
        digit3 = transformPoints(digit3Base);
      });
    }, 100);
  }
  window.addEventListener("resize", resize);

  const digit1Base = [
    { x: 50, y: 50 },
    { x: 50, y: 120 },
    { x: 120, y: 120 },
    { x: 120, y: 50 },
    { x: 120, y: 200 },
  ];

  const digit2Base = [
    { x: 180, y: 50 },
    { x: 180, y: 200 },
    { x: 260, y: 200 },
    { x: 260, y: 50 },
    { x: 180, y: 50 },
  ];

  const digit3Base = [
    { x: 320, y: 50 },
    { x: 320, y: 120 },
    { x: 390, y: 120 },
    { x: 390, y: 50 },
    { x: 390, y: 200 },
  ];

  function transformPoints(list) {
    const scale = Math.min(canvas.width / 500, canvas.height / 300);
    const offsetX = (canvas.width - 400 * scale) / 2;
    const offsetY = (canvas.height - 200 * scale) / 2;

    return list.map((p) => ({
      x: p.x * scale + offsetX,
      y: p.y * scale + offsetY,
    }));
  }

  let digit1 = [];
  let digit2 = [];
  let digit3 = [];
  resize();

  let progress = 0;
  const speed = 0.05;
  let direction = 1; // 1 for forward, -1 for reverse
  let isPaused = false;
  let pauseEndTime = 0;

  function drawDigit(points, startProgress, endProgress, opacity = 1) {
    const digitProgress = Math.max(
      0,
      Math.min(progress - startProgress, endProgress - startProgress),
    );
    const maxIndex = Math.floor(digitProgress);
    const remainder = digitProgress - maxIndex;

    // Draw all dots
    ctx.fillStyle = `rgba(255, 112, 53, ${0.3 * opacity})`;
    points.forEach((p) => {
      ctx.beginPath();
      ctx.arc(p.x, p.y, 6, 0, Math.PI * 2);
      ctx.fill();
    });

    // Draw connecting lines
    if (maxIndex > 0) {
      ctx.beginPath();
      ctx.moveTo(points[0].x, points[0].y);

      for (let i = 1; i <= maxIndex && i < points.length; i++) {
        ctx.lineTo(points[i].x, points[i].y);
      }

      if (maxIndex < points.length - 1) {
        const a = points[maxIndex];
        const b = points[maxIndex + 1];
        const ix = a.x + (b.x - a.x) * remainder;
        const iy = a.y + (b.y - a.y) * remainder;
        ctx.lineTo(ix, iy);
      }

      ctx.stroke();
    }

    // Highlight completed dots
    ctx.fillStyle = `rgba(255, 112, 53, ${opacity})`;
    for (let i = 0; i <= maxIndex && i < points.length; i++) {
      ctx.beginPath();
      ctx.arc(points[i].x, points[i].y, 6, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.strokeStyle = "#ff7035";
    ctx.lineWidth = 8;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";

    drawDigit(digit1, 0, 5);
    drawDigit(digit2, 5, 10);
    drawDigit(digit3, 10, 15);

    // Handle pause state
    if (isPaused) {
      if (Date.now() >= pauseEndTime) {
        isPaused = false;
        direction = -1;
      }
    } else {
      progress += speed * direction;

      // Reverse direction at the ends
      if (progress >= 15) {
        progress = 15;
        isPaused = true;
        pauseEndTime = Date.now() + 15000; // 15 seconds
      } else if (progress <= 0) {
        progress = 0;
        direction = 1;
      }
    }

    requestAnimationFrame(draw);
  }

  draw();
});
